import { Lock } from 'lucide-react';

// 2026-10-31 — a closed league's team is frozen as a record (no edits).
export const lastDayLabel = (frozenAt) => {
  const t = frozenAt ? new Date(frozenAt).getTime() : NaN;
  if (Number.isNaN(t)) return '';
  return new Date(t - 1).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
};

export const LeagueClosedNote = ({ team, testid, className = '' }) => {
  if (!team?.frozen) return null;
  const day = lastDayLabel(team.frozen_at);
  return (
    <div
      className={`flex items-start gap-2 rounded-xl border border-border bg-muted/40 px-3 py-2.5 text-xs ${className}`}
      data-testid={testid}
    >
      <Lock className="h-4 w-4 mt-px shrink-0 text-muted-foreground" />
      <span className="text-muted-foreground leading-snug">
        <span className="font-semibold text-foreground">This league has ended — final standings.</span>{' '}
        The team is frozen as it stood{day ? ` on ${day}` : ' on its last day'}, kept for the record. No more drafting or changes.
      </span>
    </div>
  );
};
